import React from "react";
import { withTranslation } from "react-i18next";

const FormButtons = ({
  t,
  isEditMode,
  isToastView,
  onSave,
  onCancel,
  isUpdateStaffForMultipleOffices,
}) => {
  return (
    <div className="btn-field">
      <div className="row gutters-12">
        <div className="col-md-auto">
          <button
            className="button button-round button-shadow"
            disabled={isToastView}
            title={t("accountOwner.sendInvitation")}
            onClick={onSave}
          >
            {isUpdateStaffForMultipleOffices
              ? t("save")
              : isEditMode
              ? t("accountOwner.updateUser")
              : t("accountOwner.sendInvitation")}
          </button>
        </div>
        <div className="col-md-auto">
          <button
            className="button button-round button-border button-dark"
            title={t("cancel")}
            onClick={onCancel}
          >
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(FormButtons);
